<!-- Body -->
<div class="container-fluid page-body-wrapper">

    <!-- Sidebar -->
    <app-sidebar></app-sidebar>

    <!-- Main Wrapper -->
    <div class="main-panel">
        <div class="content-wrapper pt-3">

            <ngx-loader [show]="show" [fullScreen] = "fullScreen" [template]="template" style="z-index: 500000; position: absolute;"> Loading... </ngx-loader>        

            <h3 class="bs-title" *ngIf="addflag == 0">News
            <button type="button" class="btn btn-primary" (click)="openPopupAdd()" role="button" style="float:right">+ Add</button>
            </h3>
            <h3 class="bs-title" *ngIf="addflag == 1">Add <span class="spanbs-title">News</span>
                <button type="button" class="btn btn-primary" (click)="closePopupAdd()" role="button" style="float:right">Back</button>
            </h3>
            <h3 class="bs-title" *ngIf="addflag == 2">Edit <span class="spanbs-title">News</span>
                <button type="button" class="btn btn-primary" (click)="closePopupAdd()" role="button" style="float:right">Back</button>
            </h3> 
            
            <div class="alert alert-success" id="validmsg" (click)="closealert()" style="display: none;">
                <strong>Success! {{ validmsg }} <span class="alertspan">&times;</span></strong>
            </div>
            <div class="alert alert-danger" id="errormsg" (click)="closealert()" style="display: none;">
                <strong>Something went wrong. {{ validmsg }} <span class="alertspan">&times;</span></strong>
            </div>
            <hr class="mb-2 mt-4" style="height: 0px">

            <!-- List -->
            <div class="table-responsive" *ngIf="addflag == 0">
                <table class="table table-sm row-border" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger">
                    <thead>
                    <tr>
                        <th style="width:5%">SrNo</th>
                        <th>Title</th>
                        <th>Description</th>
                        <th>Status</th>
                        <th style="text-align: center;">Action</th>
                    </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let group of InfoArray; let i = index">
                        <td style="width:5%">{{i+1}}</td>                            
                        <td>{{group['news_title']}}</td>
                        <td>{{group['news_description']}}</td> 
                        <td>
                            <span *ngIf="group['is_active'] == 1" class="btn btn-inverse-success btn-fw">Active</span>
                            <span *ngIf="group['is_active'] == 0" class="btn btn-inverse-danger btn-fw">Deactive</span>
                        </td>                                     
                        <td style="width: 10%" align="center">
                            <img src="../../../assets/img/common icons/edit_new.png" id="edituser" (click)="openPopupEdit(group)" role="button" title="Edit" />
                            <img *ngIf="group['is_active'] == 1" src="../../../assets/img/selectproduct/deactive.png" id="deleteuser" (click)="openPopupDeactivate(group)" class="ml-4" role="button" title="Deactive" />
                            <img *ngIf="group['is_active'] == 0" src="../../../assets/img/policy/tickicon.png" id="deleteuser" (click)="openPopupActivate(group)" class="ml-4" role="button" title="Active" />
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            
            <!-- Add Form -->
            <div *ngIf="addflag == 1">

                <form [formGroup]="AddInfo">                    
                    <div class="row">
                        <div class="col-sm-4">
                            <div class="form-group">
                                <label class="bs-form-label" for="news_title">Title <span class="redstar">*</span></label>
                                <input type="text" class="form-control" formControlName="news_title" id="news_title" placeholder="Title"
                                [ngClass]="{'control-red': AddInfoSubmitted && getAddInformationFormControls.news_title.errors}"
                                required />
                                <ng-container
                                    *ngIf="AddInfoSubmitted && getAddInformationFormControls.news_title.errors">
                                    <p class="error"
                                        *ngIf="AddInfoSubmitted && getAddInformationFormControls.news_title.errors.required">
                                        Title is required
                                    </p>
                                </ng-container>
                            </div>
                        </div>            
                        <div class="col-sm-4">
                            <div class="form-group">
                                <label class="bs-form-label" for="news_description">Description <span class="redstar">*</span></label>
                                <input type="text" class="form-control" formControlName="news_description" id="news_description" placeholder="Description"
                                [ngClass]="{'control-red': AddInfoSubmitted && getAddInformationFormControls.news_description.errors}"
                                required />
                                <ng-container
                                    *ngIf="AddInfoSubmitted && getAddInformationFormControls.news_description.errors">
                                    <p class="error"
                                        *ngIf="AddInfoSubmitted && getAddInformationFormControls.news_description.errors.required">
                                        Description is required
                                    </p>
                                </ng-container>
                            </div>
                        </div>   
                        
                        <div class="col-sm-4">
                            <div class="form-group">
                                <label class="bs-form-label" for="policy_document">Upload Image</label>

                                <label for="file_field5" id="custom-file-upload_policy_document" class="custom-file-upload form-control" style="text-align:center; cursor:pointer; padding: 5px;">
                                    <img src="../../../assets/img/policy/pin.png" style="width: 12px;">&nbsp; <span id="selectFile_policy_document" style="color:#4E0099; font-weight: 600; text-align:center">Add File</span>&nbsp; <span style="color:#AAAAAA">or drop file here</span>
                                </label>
                                <input id="file_field5" type="file" (change)="policy_document_change($event)" accept=".png, .jpg, .jpeg" enctype="multipart/form-data" style="display: none;" />

                            </div>
                            <small style="font-size: 12px; color:#605D62" id="small_policy_document">Upload only .png, .jpg, .jpeg files (Max size 4MB)</small>
                        </div>

                    </div>
                </form>
                <div class="col-sm-12" align="center">
                    <button type="button" class="btn btn-primary mt-3" (click)="onSubmitAdd()" role="button">Save</button>                    
                </div>
            </div>            

            <!-- Edit Form -->
            <div *ngIf="addflag == 2">
                <form [formGroup]="EditInfo">                    
                    <div class="row">
                        <div class="col-sm-4">
                            <div class="form-group">
                                <label class="bs-form-label" for="news_title_edit">Title <span class="redstar">*</span></label>
                                <input type="text" class="form-control" formControlName="news_title_edit" id="news_title_edit" placeholder="Title"
                                [ngClass]="{'control-red': EditInfoSubmitted && getEditInformationFormControls.news_title_edit.errors}"
                                required />
                                <ng-container
                                    *ngIf="EditInfoSubmitted && getEditInformationFormControls.news_title_edit.errors">
                                    <p class="error"
                                        *ngIf="EditInfoSubmitted && getEditInformationFormControls.news_title_edit.errors.required">
                                        Title is required
                                    </p>
                                </ng-container>
                            </div>
                        </div>            
                        <div class="col-sm-4">
                            <div class="form-group">
                                <label class="bs-form-label" for="news_description_edit">Description <span class="redstar">*</span></label>
                                <input type="text" class="form-control" formControlName="news_description_edit" id="news_description_edit" placeholder="Description"
                                [ngClass]="{'control-red': EditInfoSubmitted && getEditInformationFormControls.news_description_edit.errors}"
                                required />
                                <ng-container
                                    *ngIf="EditInfoSubmitted && getEditInformationFormControls.news_description_edit.errors">
                                    <p class="error"
                                        *ngIf="EditInfoSubmitted && getEditInformationFormControls.news_description_edit.errors.required">
                                        Description is required
                                    </p>
                                </ng-container>
                            </div>
                        </div>
                        <div class="col-sm-4">
                            <div class="form-group">
                                <label class="bs-form-label" for="edit_is_active">Status <span class="redstar">*</span></label>
                                <select class="form-select" formControlName="edit_is_active" id="edit_is_active" required>
                                    <option [value]="1">Active</option>
                                    <option [value]="0">Deactive</option>
                                </select>                    
                            </div>
                        </div>

                        <div class="col-sm-4 mt-3">
                            <div class="form-group">
                                <label class="bs-form-label" for="policy_document_edit">Upload Image</label>

                                <label for="file_field6" id="custom-file-upload_policy_document_edit" class="custom-file-upload form-control" style="text-align:center; cursor:pointer; padding: 5px;">
                                    <img src="../../../assets/img/policy/pin.png" style="width: 12px;">&nbsp; <span id="selectFile_policy_document_edit" style="color:#4E0099; font-weight: 600; text-align:center">Add File</span>&nbsp; <span style="color:#AAAAAA">or drop file here</span>
                                </label>
                                <input id="file_field6" type="file" (change)="policy_document_edit_change($event)" accept=".png, .jpg, .jpeg" enctype="multipart/form-data" style="display: none;" />

                            </div>
                            <small style="font-size: 12px; color:#605D62" id="small_policy_document_edit">Upload only .png, .jpg, .jpeg files (Max size 4MB)</small>
                        </div>

                        <input type="hidden" class="form-control" formControlName="edit_id" id="edit_id" />
                    </div>
                </form>
                <div class="col-sm-12" align="center">
                    <button type="button" class="btn btn-primary mt-3" (click)="onSubmitEdit()" role="button">Save</button>                    
                </div>                
            </div>
            
            <!-- Deactivate Form -->
            <div class="modal" tabindex="-1" role="dialog" [ngStyle]="{'display':displayStyleDeactivate}">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h4 class="modal-title">Deactivate Master Module</h4>
                        </div>
                        <form [formGroup]="DeactivateInfo">
                            <div class="modal-body">
                                Are you sure you want to Deactivate?
                            </div>
                            <input type="hidden" class="form-control" formControlName="delete_id" id="delete_id" />
                            <div class="modal-footer">
                                <button type="button" class="btn btn-primary" (click)="onSubmitDeactivate()"
                                    role="button">Deactivate</button>
                                <button type="button" class="btn btn-danger" (click)="closePopup()"> Close</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            <!-- Activate Form -->
            <div class="modal" tabindex="-1" role="dialog" [ngStyle]="{'display':displayStyleActivate}">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h4 class="modal-title">Activate Master Module</h4>
                        </div>
                        <form [formGroup]="ActivateInfo">
                            <div class="modal-body">
                                Are you sure you want to Activate?
                            </div>
                            <input type="hidden" class="form-control" formControlName="active_delete_id" id="active_delete_id" />
                            <div class="modal-footer">
                                <button type="button" class="btn btn-primary" (click)="onSubmitActivate()"
                                    role="button">Activate</button>
                                <button type="button" class="btn btn-danger" (click)="closePopup()"> Close</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

        </div>
        <app-footer></app-footer>
    </div>  
</div>